angular.module('dnecom')
    .controller('TransactionModalController', ["$scope", "$uibModalInstance", "$http", "$timeout", "notifications", "transaction", function($scope, $uibModalInstance, $http, $timeout, notifications, transaction) {
        $scope.transactionStatuses = TemplateData.value('transactionStatuses');
        $scope.productStatuses = TemplateData.value('productStatuses');
        $scope.transaction = transaction;
        $scope.transaction.originalStatus = transaction.status;
        $scope.transaction.sendStatusChangeMessage = true;

        if (!transaction.status) {
            transaction.status = 'new';
        }

        $http.get(Routing.generate('transaction_products', {
            id: transaction.storeId,
            transactionId: transaction.id
        }))
            .then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                $timeout(function() {
                    $scope.transaction.products = response.data.products;
                });
            }, function() {
                notifications.danger('Request error.');
            })
        ;

        $scope.saveTransaction = function() {
            $http.put(Routing.generate('transaction_update', {
                id: transaction.storeId,
                transactionId: transaction.id
            }), transaction)
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    $timeout(function() {
                        $scope.transaction.id = response.data.id;
                        notifications.success(response.data.message);
                    });
                }, function() {
                    notifications.danger('Request error.');
                }).finally($uibModalInstance.close)
            ;
        };

        $scope.closeModal = function() {
            $uibModalInstance.dismiss();
        };
    }])
